import e from "./SchemaEnumPropertyItem.vue_vue_type_script_setup_true_lang.js";
//#region src/schema/SchemaEnumPropertyItem.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=SchemaEnumPropertyItem.vue.js.map